import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DAYOFYEAR = () => {
  return (
    <CardSection id="DAYOFYEAR" title="DAYOFYEAR">
      <Paragraph>날짜의 해당 연도 시작일로부터의 일 수를 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DAYOFYEAR(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 일을 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>DAYOFYEAR(`Date`)</Paragraph>
        <Img src="computeDayOfYear" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>반환되는 값의 범위는 1~365(윤년에는 366)입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
